import { Injectable } from '@angular/core';
import { AuthEntity, LoginModel, UserEntity } from '@repo/types';
import { BaseApi } from './_base-api';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends BaseApi<any> {

  constructor() {
    super('');
  }

  login(model: LoginModel) {
    return http$.post<AuthEntity>('/AdminPanel/Login', model)
  }
}
